module.exports = __webpack_public_path__ + "img/tp4.45778490.png";